// extracted by mini-css-extract-plugin
export default {"cardDiv":"MatchDetails_cardDiv__lj6qi"};